import { MagicBellProvider } from '@magicbell/react-headless';
import type React from 'react';

import { webConfig } from '@gitbook/env';

import { useCurrentUser } from '../../state';

export function NotificationsProvider(props: {
    children: React.ReactElement | React.ReactElement[];
}): React.ReactElement {
    const { children } = props;
    const user = useCurrentUser();

    if (!user || !webConfig.magicbell.apiKey) {
        return <>{children}</>;
    }

    return (
        <MagicBellProvider
            apiKey={webConfig.magicbell.apiKey}
            userExternalId={user.uid}
            stores={[
                { id: 'unread', defaultQueryParams: { read: false } },
                { id: 'all', defaultQueryParams: {} },
            ]}
        >
            {children}
        </MagicBellProvider>
    );
}
